import dayjs from 'dayjs'
import { render } from 'react-dom'

const config = {
  searchMode: 'group',
  rowSelection: false,
  listTitle: '客户谈单',
  columns: [
    {
      title: '谈单ID',
      dataIndex: 'id',
      width: 200,
      fixed: 'left',
      render: 'IDRender',
    },
    {
      title: '销售计划ID',
      dataIndex: 'clueId',
      width: 200,
      ellipsis: true,
    },
    {
      title: '门店',
      dataIndex: 'companyName',
      ellipsis: true,
      width: 200,
    },
    {
      title: '客户姓名',
      dataIndex: 'customerName',
      width: 150,
    },
    {
      title: '客户电话',
      dataIndex: 'customerPhone',
      width: 150,
    },
    {
      title: '楼盘名称',
      dataIndex: 'buildingName',
      width: 200,
      ellipsis: true,
    },
    {
      title: '完善率',
      dataIndex: 'perfectionRate',
      render: v => (v ? v + '%' : '0%'),
      width: 150,
    },
    {
      title: '本次谈单备注',
      dataIndex: 'remark',
      width: 200,
      ellipsis: true,
    },
    {
      title: '更新人',
      dataIndex: 'modifiedByName',
      width: 150,
    },
    {
      title: '更新时间',
      dataIndex: 'lastUpdatedTime',
      render: (v: number) => (v ? dayjs(v).format('YYYY-MM-DD HH:mm:ss') : ''),
      width: 200,
    },
    {
      title: '创建人',
      dataIndex: 'createdByName',
      width: 150,
    },
    {
      title: '创建时间',
      dataIndex: 'createdTime',
      render: (v: number) => (v ? dayjs(v).format('YYYY-MM-DD HH:mm:ss') : ''),
      width: 200,
    },
    // {
    //   title: "操作",
    //   dataIndex: "#",
    //   fixed: 'right',
    //   width: 250,
    //   render: "operationCell"
    // }
  ],
  search: [
    {
      name: 'id',
      label: '谈单ID',
      formItemProps: {
        getValueFromEvent: (e: any) => e?.target?.value.replace(/\D.*/, ''),
      },
    },
    {
      name: 'clueId',
      label: '销售计划ID',
      formItemProps: {
        getValueFromEvent: (e: any) => e?.target?.value.replace(/\D.*/, ''),
      },
    },
    {
      name: 'customerName',
      label: '客户名称',
    },
    {
      name: 'customerPhone',
      label: '客户电话',
    },
    {
      name: 'buildingName',
      label: '楼盘名称',
    },
  ],
  // footer: [
  //   {
  //     label: '客户到店',
  //     type: 'primary',
  //     events: ['onClick:onArrival']
  //   }
  // ]
}

export default config
